import { LetterbookSettingType } from "features/Letterbooks/types";
import Avatar from "hardcover-ui/components/Avatar";
import generateUrl from "features/Letterbooks/utils/generateUrl";
import { Link } from "@inertiajs/react";
import trash from "icons/solid/trash.svg";
import Icon from "hardcover-ui/components/Icon";
import AddNewColumn from "./AddNewColumn/AddNewColumn";

export default function TableHeaders({
  settings,
}: {
  settings: LetterbookSettingType;
}) {
  const { tableColumns } = settings;

  return (
    <thead>
      <tr>
        {tableColumns.map((column) => (
          <th className="text-left" key={column.key}>
            <div className="group flex justify-between items-center">
              <div className="flex items-center">
                <span className=" flex flex-row whitespace-nowrap">
                  {column.user ? (
                    <Avatar
                      image={column.user.image}
                      size="xs"
                      className="mr-1"
                      alt={column.user.username}
                    />
                  ) : (
                    false
                  )}
                  {column.title}
                </span>

                <Link
                  className="ml-1 invisible group-hover:visible px-1 py-1 hover:text-red-500"
                  href={generateUrl({
                    settings,
                    settingOverrides: { removeColumn: column.key },
                  })}
                >
                  <Icon icon={trash} size="sm" className="fill-current" />
                </Link>
              </div>

              {column === tableColumns[tableColumns.length - 1] ? (
                <AddNewColumn settings={settings} />
              ) : (
                false
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
}
